"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IntroHeadlineCatalog() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const trustBadges = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624643/img/industry_standard_certification.png",
    alt: "Industry Standard Certification"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624643/img/professional_growth_award.png",
    alt: "Professional Growth Award"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624643/img/ethical_business_seal.png",
    alt: "Ethical Business Seal"
  }];
  return <section data-section-id="253416" id="fair-and-transparent-compensation" className="bg-background py-20 px-4 md:px-8 overflow-hidden">
      <div ref={ref} className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="flex justify-center mb-10">
          <Separator className="w-16 h-0.5 bg-secondary" />
        </div>

        {}
        <h2 className="font-default text-3xl md:text-5xl font-bold text-primary mb-10 leading-tight tracking-tight">
          Fair and Transparent Compensation
        </h2>

        {}
        <div className="space-y-6 text-muted-foreground text-lg md:text-xl leading-relaxed max-w-3xl mx-auto">
          <p className="font-default">
            Fair pay reflects responsibility, contribution, and growth. We believe in practical, 
            straightforward compensation aligned with your role and development.
          </p>
          <p className="font-semibold text-foreground font-default">
            RiverBend is committed to a culture where financial rewards are clearly 
            linked to the value you bring and the milestones you achieve within our team.
          </p>
          <p className="font-default">
            Our promise is to maintain a structure that is both competitive and equitable, 
            ensuring every team member feels valued for their unique expertise and dedication.
          </p>
          <p className="font-default">Explore our career opportunities and learn more about our commitment to you.</p>
        </div>

        {}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-12">
          <Link to="/CareerOpportunitiesPage" className="w-full sm:w-auto">
            <Button variant="outline" size="lg" className="w-full sm:w-[200px] border-primary text-primary hover:bg-primary-100 rounded-md shadow-sm transition-colors">
              View Careers
            </Button>
          </Link>
          <Link to="/OurCommitmentToEmployeesPage" className="w-full sm:w-auto">
            <Button variant="outline" size="lg" className="w-full sm:w-[200px] border-secondary text-secondary hover:bg-secondary-100 rounded-md shadow-sm transition-colors">
              Our Commitment
            </Button>
          </Link>
        </div>

        {}
        <div className="mt-24 space-y-8">
          <p className="text-muted-foreground text-lg font-default">
            Building a foundation of integrity
          </p>
          <h3 className="font-default text-2xl md:text-3xl font-bold text-primary-400 uppercase tracking-widest">
            We grow by investing in our people
          </h3>

          {}
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 pt-8">
            {trustBadges.map((badge, index) => <div key={index} data-index={index} className="flex-shrink-0 grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition-all duration-300">
                <img src={badge.src} data-wvc-srcset={`${badge.src}-wvc-srcset`} data-wvc-sizes={`${badge.src}-wvc-sizes`} alt={badge.alt} className="h-16 md:h-24 w-auto object-contain" loading="lazy" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}